const commonHeaders = process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}

export default fetch => ({
  getUrgentOrders (
    conditions,
    loading
  ) {
    return fetch({
      url: '/api/v1/urgentorder/GetUrgentOrderList',
      data: conditions,
      headers: commonHeaders,
      loading
    })
  },
  getUrgentOrder (
    FlowInstanceId,
    loading
  ) {
    return fetch({
      url: '/api/v1/urgentorder/GetUrgentOrderInfo',
      data: { FlowInstanceId },
      headers: commonHeaders,
      loading
    })
  },
  applyUrgetnOrder (data, loading) {
    return fetch({
      url: '/api/v1/urgentorder/OrderUrgentCreate',
      data,
      headers: commonHeaders,
      loading
    })
  },
  getSpecialDeliveries (
    conditions,
    loading
  ) {
    return fetch({
      url: '/api/v1/specialdelivery/GetSpecialDeliveryList',
      data: conditions,
      headers: commonHeaders,
      loading
    })
  },
  getSpecialDeliverie (
    InstanceId,
    loading
  ) {
    return fetch({
      url: '/api/v1/specialdelivery/GetSpecialDeliveryInfo',
      data: { InstanceId },
      headers: commonHeaders,
      loading
    })
  },
  getOrderInfo (SaleOrderNumber, loading, onBusinessError) {
    return fetch({
      url: '/api/v1/urgentorder/GetOrderInfoBySO',
      data: { SaleOrderNumber },
      headers: commonHeaders,
      loading,
      onBusinessError
    })
  },
  getTransportTypes (loading) {
    return fetch({
      url: '/api/v1/specialdelivery/GetTransportModeList',
      headers: commonHeaders,
      loading
    })
  },
  getFreightModes (loading) {
    return fetch({
      url: '/api/v1/specialdelivery/GetFreightModeList',
      headers: commonHeaders,
      loading
    })
  },
  applySpecialDelivery (data, loading) {
    return fetch({
      url: '/api/v1/specialdelivery/SpecialDeliveryCreate',
      data,
      headers: commonHeaders,
      loading
    })
  }
})
